// extracted by mini-css-extract-plugin
module.exports = {"container":"avatar_container__vz74j","dropdown-content":"avatar_dropdown-content__zQ7j3"};